var _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoPassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.32294 9.27734C1.32294 7.96204 1.32294 7.30438 1.62023 6.82191C1.78406 6.55603 2.00788 6.33221 2.27376 6.16838C2.75623 5.87109 3.41388 5.87109 4.72919 5.87109H9.27085C10.5862 5.87109 11.2438 5.87109 11.7263 6.16838C11.9922 6.33221 12.216 6.55603 12.3798 6.82191C12.6771 7.30438 12.6771 7.96204 12.6771 9.27734V9.27734C12.6771 11.2503 12.6771 12.2368 12.2312 12.9605C11.9854 13.3593 11.6497 13.695 11.2509 13.9408C10.5272 14.3867 9.54069 14.3867 7.56773 14.3867H6.43231C4.45935 14.3867 3.47287 14.3867 2.74917 13.9408C2.35035 13.695 2.01462 13.3593 1.76887 12.9605C1.32294 12.2368 1.32294 11.2503 1.32294 9.27734V9.27734Z",
    stroke: "#414D5E",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83858 5.16146V4.45182C9.83858 2.88414 8.56772 1.61328 7.00004 1.61328V1.61328C5.43236 1.61328 4.1615 2.88414 4.1615 4.45182V5.16146",
    stroke: "#414D5E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.99999,
    cy: 10,
    r: 1.2,
    fill: "#414D5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPassword);
export default __webpack_public_path__ + "static/media/ico-password.5b3203b2591d848567ac90d3b2b3db47.svg";
export { ForwardRef as ReactComponent };